const nweb_index = () => import(/* webpackChunkName: "nweb" */ '../nweb/index');
const nweb_companySyn = () => import(/* webpackChunkName: "nweb" */ '../nweb/companySyn/index');
const nweb_panoramaInfo = () => import(/* webpackChunkName: "nweb" */ '../nweb/panoramaInfo/index');
const cooperationCases = () => import(/* webpackChunkName: "nweb" */ '../nweb/cooperationCases/index');
const templatea_m_a = () => import(/* webpackChunkName: "nweb" */ '../nweb/templatea_m/index');
const templatea_m_a_detail = () => import(/* webpackChunkName: "nweb" */ '../nweb/templatea_m/detail');
const templatea_m_new = () => import(/* webpackChunkName: "nweb" */ '../nweb/templatea_m_new/index');
const templatea_m_new_detail = () => import(/* webpackChunkName: "nweb" */ '../nweb/templatea_m_new/detail');
const templatea_m1 = () => import(/* webpackChunkName: "nweb" */ '../nweb/templatea_m1/index');
const templatea_m1_detail = () => import(/* webpackChunkName: "nweb" */ '../nweb/templatea_m1/detail');
var nweb_router = [
    {
      name: "/nweb/index",
      path: "/nweb/index",//首页√
      component: nweb_index,
      meta: { title: "首页", name: 'viewport', content: "width=device-width,initial-scale=0.1,maximum-scale=2.0,user-scalable=1" },
    },
    {
      name: "/nweb/companySyn/index",
      path: "/nweb/companySyn/index", //公司简介√
      component: nweb_companySyn,
      meta: { title: "公司简介", name: 'viewport', content: "width=device-width,initial-scale=0.1,maximum-scale=2.0,user-scalable=1" },
    },
    {
      name: "/nweb/panoramaInfo/index",
      path: "/nweb/panoramaInfo/index", //全景资讯√
      component: nweb_panoramaInfo,
      meta: { title: "全景资讯", name: 'viewport', content: "width=device-width,initial-scale=0.1,maximum-scale=2.0,user-scalable=1" },
    },
    {
      name: "/nweb/cooperationCases/index",
      path: "/nweb/cooperationCases/index", //全景资讯√
      component: cooperationCases,
      meta: { title: "全景展示", name: 'viewport', content: "width=device-width,initial-scale=0.1,maximum-scale=2.0,user-scalable=1" },
    },
    {
      path: '/nweb/templatea_m',
      name: '/nweb/templatea_m', //移动端首页
      component: templatea_m_a,
      meta: {
        title: '首页',
        name: 'viewport',
        content: 'width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
      }
    },
    {
      path: '/nweb/templatea_m/detail',
      name: '/nweb/templatea_m/detail', //移动端首页
      component: templatea_m_a_detail,
      meta: {
        title: '详情',
        name: 'viewport',
        content: 'width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
      }
    },
    
    {
      path: '/nweb/templatea_new',
      name: '/nweb/templatea_new', //移动端首页
      component: templatea_m_new,
      meta: {
        title: '首页',
        name: 'viewport',
        content: 'width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
      }
    },
    {
      path: '/nweb/templatea_new/detail',
      name: '/nweb/templatea_new/detail', //移动端首页
      component: templatea_m_new_detail,
      meta: {
        title: '详情',
        name: 'viewport',
        content: 'width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
      }
    },
    
    {
      path: '/nweb/templatea_m1',
      name: '/nweb/templatea_m1', //移动端首页
      component: templatea_m1,
      meta: {
        title: '首页',
        name: 'viewport',
        content: 'width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
      }
    },
    {
      path: '/nweb/templatea_m1/detail',
      name: '/nweb/templatea_m1/detail', //移动端首页
      component: templatea_m1_detail,
      meta: {
        title: '详情',
        name: 'viewport',
        content: 'width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
      }
    },
];
export {
    nweb_router
}



// WEBPACK FOOTER //
// ./src/nweb/router/index.js